
import { Base } from '../base-component';

import './branch-locator.component.scss';

import * as _ from 'lodash';

export class BranchLocator extends Base {

    endpoint: string;
    distanceIcon: string;
    markerIcon: string;
    distanceSVG: string;
    searchTerm:string;
    map: google.maps.Map;
    currentLocation: any;
    activeFilters: string[];
    searchResults: any[];
    mapMarkers: any[];

	constructor(element: Element){

        super(element);
        this.event.register('mapInitialised', null, this.setMapOptions.bind(this));

	}

	init(){
        
        this.activeFilters = [];
        this.mapMarkers = [];

        this.endpoint = this.element.getAttribute('data-endpoint');
        this.distanceIcon = this.element.getAttribute('data-distanceIcon');
        this.markerIcon = this.element.getAttribute('data-markerIcon');

        this.http.get(this.distanceIcon)
			.then( (response) => {

                this.distanceSVG = response.data;
                
			}
		);

		if ("geolocation" in navigator) {

		} else {

            /* geolocation IS NOT available */
            
            Array.from(this.element.querySelectorAll('.js-location')).map((item) => {
            
                item.classList.add('button--disabled');
    
            });

		}        

	}

	bindEvents() {


        Array.from(this.element.querySelectorAll('.js-location')).map((item) => {
            
            item.addEventListener("click", (e)=> {

                if ("geolocation" in navigator) {
    
                    navigator.geolocation.getCurrentPosition((position) => {
                        this.currentLocation = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };
                        console.log(position);
                        this.map.setCenter(this.currentLocation);
                        this.map.setZoom(13);
    
                    });
        
                }
    
            });

        });

		document.getElementsByClassName('js-search')[0].addEventListener('click', (e) => {

			e.preventDefault();
            
            this.searchTerm = (<HTMLInputElement>document.getElementById('branch-locator__search-input')).value;

			this.http.get(this.endpoint + `?searchTerm=${this.searchTerm}`).then((response) => {
                
                if (response.data.length > 0) {
                    
                    this.searchResults = response.data;

                    let markers = _.map(response.data, (loc:any)=> {
                        return {
                            coordinates: loc.coordinates,
                            icon: this.markerIcon,
                            title: loc.title,
                            info: loc.address
                        }
                    });
                    
                    this.setMarkers(markers);

                    document.querySelector('.branch-locator__results__content').innerHTML = "";

                    let docfragment = document.createDocumentFragment();
                    
                    let index = 0;
                    
                    response.data.forEach(item => {
                        
                        docfragment.appendChild(this.renderLocation(item,index));
                        
                        index++;
        
                    });
        
                    document.getElementsByClassName('branch-locator__results__content')[0].appendChild(docfragment);

                    document.getElementsByClassName('branch-locator__results')[0].classList.remove('branch-locator__results--hide');

                    Array.from(this.element.querySelectorAll('.branch-locator__message')).map((item) => {
                        item.classList.remove('d-none');
                        item.classList.remove('d-lg-block');
                        
                        item.classList.add('branch-locator__message--hide');
                    });

                }else {

                    this.searchResults = [];

                    Array.from(this.element.querySelectorAll('.branch-locator__message')).map((item) => {
                        item.classList.remove('d-none');
                        item.classList.remove('d-lg-block');
                        
                        item.classList.add('branch-locator__message--hide');
                    });

                    document.getElementsByClassName('branch-locator__notfound')[0].classList.add('branch-locator__notfound--show');

                    document.getElementsByClassName('branch-locator__notfound__term')[0].innerHTML = `"${this.searchTerm}"`;

                }

			});

        });

        let filters = this.element.querySelectorAll('.js-filter');
        for (let index = 0; index < filters.length; index++) {
            this.activeFilters.push(filters[index].getAttribute('data-filter'));
        }

        Array.from(this.element.querySelectorAll('.js-filter')).map((item) => item.addEventListener('click', (event) => {
  
            this.filterClick(event);

        }));

		document.addEventListener('click', (e: any) => {
			
			let composedPath = (el) => {
				
				let path = [];
			
				while (el) {
			
					path.push(el);
			
					if (el.tagName === 'HTML') {
			
						path.push(document);
						path.push(window);
			
						return path;
					}
			
					el = el.parentElement;
				}
			}
			
			let path = e.path || (e.composedPath && e.composedPath()) || composedPath(e.target);

			let hasClass = (cls: string) => {

				return _.filter(path, (p)=> {

						let exists = false;
						_.each(p.classList, (cl) => {

							if(cl === cls) { 
								exists = true
							}

						})

						if (p.classList && exists ) {
							return p;
						}

					})[0];

			}

			if (hasClass('branch-locator-item')) {
				
				this.expandLocation(hasClass('branch-locator-item'));
				
			}

		}, false);

    }

    callback(response, status) {

        console.log(response, status);
        // See Parsing the Results for
        // the basics of a callback function.
    }

    filterClick(e) {

        let filter = e.srcElement.getAttribute('data-filter');
        
        let filterIndex = this.activeFilters.indexOf(filter);

        if (filterIndex > -1) {

            this.activeFilters.splice(filterIndex, 1);

        }else{

            this.activeFilters.push(filter);

        }

        let filteredResults = _.filter(this.searchResults, (res)=> {

            return _.some(res.services, (el) => 
                _.includes(this.activeFilters, el)
            );

        });

        this.renderFiltered(_.take(filteredResults ,4));

    }
    
    renderFiltered(datasource){

        document.getElementsByClassName('branch-locator__results__content')[0].innerHTML = "";
        
        let markers = _.map(datasource, (loc: any)=> {
            return {
                coordinates: loc.coordinates,
                icon: this.markerIcon,
                title: loc.title,
                info: loc.address
            }
        });
        
        this.setMarkers(markers);

        document.querySelector('.branch-locator__results__content').innerHTML = "";

        let docfragment = document.createDocumentFragment();
        
        let index = 0;
        
        datasource.forEach(item => {
            
            docfragment.appendChild(this.renderLocation(item,index));
            
            index++;

        });

        document.getElementsByClassName('branch-locator__results__content')[0].appendChild(docfragment);

    }

    setMarkers(markers) {

        for (var i = 0; i < this.mapMarkers.length; i++) {
            this.mapMarkers[i].setMap(null);
        }

        let mIndex:number = 0;

		for (const marker of markers) {

			const markerInstance = new google.maps.Marker({
				position: marker.coordinates,
				icon: marker.icon,
				title: marker.title,
                map: this.map,
                zIndex: mIndex
            });
            
            this.mapMarkers.push(markerInstance);

			const infoWindow = new google.maps.InfoWindow({
				content: marker.info
			});

			markerInstance.addListener('click', (e) => {
                infoWindow.open(this.map, markerInstance);
                console.log(markerInstance);

                this.expandLocation(document.querySelector(`.branch-locator-item[data-index='${markerInstance.getZIndex()}']`));


			});

            mIndex++;

		}

	}
    
    setMapOptions(event, mapData) {

		this.map = mapData.map;

		/* const infowindow = new google.maps.InfoWindow({
			content: "<strong>test</strong>"
		});

		google.maps.event.addListener(marker, 'click', function() {
			infowindow.open(map,marker);
		});

		google.maps.event.addDomListener(window, 'resize', function() {
			map.setCenter(mapLatLng);
		}); */

	}

	expandLocation(element) {

		let locations = document.getElementsByClassName('branch-locator-item');
		
		for (let i = 0; i < locations.length; i++) {
			locations[i].classList.remove('branch-locator-item--open');
		}

        element.classList.add('branch-locator-item--open');

        this.map.setCenter(this.searchResults[element.getAttribute('data-index')].coordinates);
        this.map.setZoom(13);
	}

	renderLocation(input,index) {

        let contact = "";
        let hours = "";
        let services = "";

        input.contact.forEach(element => {
            contact += `
                <span class="branch-locator-item__info">
                    ${element}
                </span>
            `;
        });

        input.operatingHours.forEach(element => {
            hours += `
                <span class="branch-locator-item__info">
                    ${element}
                </span>
            `;
        });

        let serviceCount = 0;
        input.services.forEach(element => {
            serviceCount++;
            if (serviceCount == input.services.length) {
                services += element;
            } else {
                services += `${element}, `;
            }
        });
		
		let output = `
		
			<div class="branch-locator-item ${index == 0 ? 'branch-locator-item--open': '' }"
                data-component="branch-locator-item"
                data-index="${index}">
				
				<div class="branch-locator-item__title">

					<div class="title title--module-sub-title">
						${input.title}
					</div>

					<div class="branch-locator-item__distance">

						<i class="icon">
							${this.distanceSVG}
						</i>

						<span class="branch-locator-item__distance__title title title--entrance">
							10,3 km
						</span>

					</div>

				</div>

				<div class="branch-locator-item__content">
						
					<p>
                        ${input.address}
					</p>

					<div class="row">

						<div class="col-6">

							<div class="title title--notes">
								Telephone
							</div>

							${contact}

						</div>

						<div class="col-6">

							<div class="title title--notes">
								opening hours
							</div>

							${hours}

						</div>

						<div class="col-6">

							<div class="title title--notes">
								services
							</div>

							<span class="branch-locator-item__info">
								${services}
							</span>
							
						</div>

					</div>

					<a class="button button--large" href="http://maps.google.com/maps?q=${input.coordinates.lat},${input.coordinates.lng}" target="_blank">
					
						Get Directions
				
					</a>

				</div>

			</div>
		
		`;

		return document.createRange().createContextualFragment(output);
	}

}



// WEBPACK FOOTER //
// ./components/branch-locator/branch-locator.component.ts